@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (isLoaded()) {
    <div class="configuration">
      <app-unit-information
        (tagInformationUpdated)="updateTaggingDetails($event)"
        [line]="entityLine()"
        [isOem]="isOem()"
        [tags]="taggingDetails()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"
        (valueChanged)="validateUnit()"
        (quantityChanged)="quantityChanged()"
        [selectionEntities]="selectionEntities()"></app-unit-information>
      <app-air-handler-unit-system-inputs
        (valueChanged)="validateAndRateUnit()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()"
        (unitTypeChanged)="unitTypeChanged()"
        (systemTypeChanged)="systemTypeChanged()"></app-air-handler-unit-system-inputs>
      <app-air-handler-unit-return-air-module
        [selectionEntities]="selectionEntities()"
        [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()"
        (valueChanged)="validateAndRateUnit()"></app-air-handler-unit-return-air-module>
      <app-air-handler-unit-performance-input
        (valueChanged)="validateAndRateUnit()"
        [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()"
        (inputUnitsChanged)="inputUnitsChanged()"
        [ratingResponse]="unitRatingResponse()"></app-air-handler-unit-performance-input>
      <app-air-handler-unit-performance-output [selectionEntities]="selectionEntities()" [ratingResponse]="unitRatingResponse()"></app-air-handler-unit-performance-output>
      @if (unitRatingResponse() && (unitRatingResponse().FanCurveData?.length || 0) > 0) {
        <app-air-handler-unit-fan-curve-chart
          [operatingPoint]="operatingPoint()"
          [fanCurves]="unitRatingResponse().FanCurveData"
          [maxAirflow]="unitRatingResponse().MaxAirflowValue"
          [maxTsp]="unitRatingResponse().MaxTspValue"></app-air-handler-unit-fan-curve-chart>
        <app-air-handler-unit-fan-performance-summary
          [operatingPoint]="operatingPoint()"
          [performanceSummary]="unitRatingResponse().PerformanceSummary"></app-air-handler-unit-fan-performance-summary>
      }
      <app-air-handler-unit-mechanical-connections
        [selectionEntities]="selectionEntities()"
        [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()"
        [imagePrefix]="getImagePrefix()"
        (valueChanged)="validateUnit()"></app-air-handler-unit-mechanical-connections>
      <app-air-handler-unit-access-module
        [selectionEntities]="selectionEntities()"
        [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()"
        (valueChanged)="validateUnit()"></app-air-handler-unit-access-module>
      <app-air-handler-unit-controls
        [selectionEntities]="selectionEntities()"
        [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()"
        (valueChanged)="validateUnit()"></app-air-handler-unit-controls>
      <app-air-handler-unit-coil-module
        [selectionEntities]="selectionEntities()"
        [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()"
        (valueChanged)="validateUnit()"></app-air-handler-unit-coil-module>
      <app-air-handler-unit-standard-features
        [selectionEntities]="selectionEntities()"
        [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()"
        (valueChanged)="validateUnit()"></app-air-handler-unit-standard-features>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices
      [modelImagePath]="unitImagePath()"
      [messages]="messages()"
      [skus]="skus()"
      [sfrEntries]="sfrEntries()"
      [entityLeadTime]="entityLeadTime"
      [configurationLeadTime]="configurationLeadTime()"
      (sfrFlagChanged)="sfrFlagChanged()"></app-skus-and-prices>
  </div>
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <span class="busyLabel">Please Wait...</span>
    </div>
  </div>
}
